// extracted by mini-css-extract-plugin
export default {"text":"_1sCK","title":"_3txX","buttons":"_3I1s","icon":"_4xP6","sm":"Juvn","lg":"_27tW","md":"PW5B"};